import *as mobx from 'mobx'
import EventEmitter from 'wolfy87-eventemitter';

class BaseStateProxy extends EventEmitter{
    listeners = [];
    base = null;
    constructor(state){
        super();
        this.state = mobx.observable(state);
        this.listeners = [];
        this.init();
    }
    init(){

    }

    getValue(key) {
        if (!!key) {
            const value = mobx.toJS(this.state[key]);
            if ((typeof value !== "object") || Array.isArray(value)) return value;
            return (!value || Object.keys(value).length === 0) ? null : value;
        } else {
            return mobx.toJS(this.state);
        }
    }

    /**
     * 销毁
     */
    destroy() {
        this.listeners.forEach((item) => {
            if (typeof item === "function")
                item();
        });
    }
}
export default BaseStateProxy;
